import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    input:
      'border-bg-items-black text-bg-items-black placeholder:text-bg-items-black focus:border-brand-400 active:border-brand-400 h-[50px] border-1 bg-white py-[15.5px] pr-[50px] pl-[16px] text-base font-light tracking-[0.06em] uppercase focus:border-2 active:border-2',
    inputContainer: 'relative flex w-full items-center',

    closeBg: 'absolute grid size-6 place-items-center rounded-full bg-gray-100',
    close: 'text-icon-secondary absolute top-0',
    arrow: 'size-[24px] rotate-270',
    button:
      'absolute top-0 h-[24px] w-[24px] border-0 bg-transparent p-0 hover:bg-transparent',

    loadingContainer:
      'border-brand-400 absolute left-0 flex size-full items-center justify-center border-2 bg-white',
    loading: 'loading text-brand-400 h-5 w-16 transform transition-opacity',
    message: 'text-inactive pt-1 text-sm font-light'
  },
  variants: {
    error: {
      true: {
        input: 'border-brand-400 border-2',
        message: 'text-text-error'
      }
    },
    success: {
      true: {
        message: 'text-black'
      }
    },
    filled: {
      true: {
        input: '!heading-s-bold'
      }
    }
  }
});
